import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJGeneratePrivacySettings from '../../../FJTextToImage/FJTextToImageLeft/view/FJGeneratePrivacySettings.jsx';
import FJGeneratePrivacySettingsIcon from '../../../FJImageToImage/FJGeneratePrivacySettings/FJGeneratePrivacySettings.jsx';
import { useMemo } from 'react';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';

const FJGeneratePrivacySettingsContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const ivPrivacyStatus = useSelector(state => state.AIVideoGenerator.ivPrivacyStatus);
    const tvPrivacyStatus = useSelector(state => state.AIVideoGenerator.tvPrivacyStatus);
    const evPrivacyStatus = useSelector(state => state.AIVideoGenerator.evPrivacyStatus);
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);

    const privacyStatus = useMemo(() => {
        switch (tabIndex) {
            case AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO:
                return ivPrivacyStatus;
            case AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO:
                return tvPrivacyStatus;
            case AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO:
                return evPrivacyStatus;
            default:
                return ivPrivacyStatus;
        }
    }, [ivPrivacyStatus, tvPrivacyStatus, evPrivacyStatus, tabIndex]);

    const _onPrivacySettingChange = (value, callback) => {
        switch (tabIndex) {
            case AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO:
                dispatch(FJActionAIVideoGenerator.setIVPrivacyStatusAction(value));
                break;
            case AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO:
                dispatch(FJActionAIVideoGenerator.setTVPrivacyStatusAction(value));
                break;
            case AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO:
                dispatch(FJActionAIVideoGenerator.setEVPrivacyStatusAction(value));
                break;
        }
        callback(true);
    };

    return (
        <>
            {tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO ? (
                <FJGeneratePrivacySettingsIcon
                    privacyStatus={privacyStatus}
                    onPrivacySettingChange={_onPrivacySettingChange}
                    placement='topLeft'
                />
            ) : (
                <FJGeneratePrivacySettings
                    privacyStatus={privacyStatus}
                    onPrivacySettingChange={_onPrivacySettingChange}
                    tabIndex={tabIndex}
                />
            )}
        </>
    );
};

export default FJGeneratePrivacySettingsContainer;
